import { render, staticRenderFns } from "./MenuUserNotifications.vue?vue&type=template&id=00c72dc3&scoped=true"
import script from "./MenuUserNotifications.vue?vue&type=script&lang=js"
export * from "./MenuUserNotifications.vue?vue&type=script&lang=js"
import style0 from "./MenuUserNotifications.vue?vue&type=style&index=0&id=00c72dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c72dc3",
  null
  
)

export default component.exports